/*
 * Come back to the personal screen that asked for the sign-in (QA 2026-10-31). Shopify's sign-in lands on the home (/?shop_sign_in=true) and
 * ignores return_url, so snippets/nc-account-gate.liquid leaves the page it wanted in sessionStorage ('nc-return-to', path + query, 10 minutes)
 * and this file, loaded on every page by the header, takes the person there ONCE when they arrive signed in on the home.
 *   NcReturnTo.valid(path)            true only for a personal screen of this theme (same origin path, no scheme, no //, no backslash)
 *   NcReturnTo.save(path, now)        stores it (ignored when invalid)
 *   NcReturnTo.take(now)              the stored path if it is fresh and valid, else ''; the key is always removed
 *   NcReturnTo.restore()              the guarded jump: signed in + on the home or shop_sign_in=true + a taken path that is not this page
 * No loops: the key is removed before the jump, and a page other than the home never jumps.
 */
(function (root) {
  var KEY = 'nc-return-to';
  var TTL = 10 * 60 * 1000;
  var PAGES = ['/pages/profile', '/pages/mis-favoritos', '/pages/historial', '/pages/editar-perfil'];

  function valid(path) {
    if (typeof path !== 'string' || path.length > 300 || path.charAt(0) !== '/' || path.charAt(1) === '/' || path.indexOf('\\') >= 0) return false;
    if (/[\u0000-\u001f]/.test(path)) return false;
    var base = path.split('#')[0].split('?')[0];
    if (PAGES.indexOf(base) < 0) return false;
    // the notices screen is the profile page with ?view=nc-avisos; any other query on these pages is harmless but only that one is expected
    var q = path.split('#')[0].split('?')[1];
    return !q || /^[\w=&%.-]*$/.test(q);
  }

  function store() { try { return root.sessionStorage; } catch (e) { return null; } }

  function save(path, now) {
    var s = store();
    if (!s || !valid(path)) return false;
    try { s.setItem(KEY, JSON.stringify({ p: path, t: typeof now === 'number' ? now : Date.now() })); return true; } catch (e) { return false; }
  }

  function take(now) {
    var s = store(), raw = null, out = '';
    if (!s) return '';
    try { raw = s.getItem(KEY); s.removeItem(KEY); } catch (e) { return ''; }
    if (!raw) return '';
    try {
      var v = JSON.parse(raw), t = typeof now === 'number' ? now : Date.now();
      if (v && typeof v.t === 'number' && t - v.t >= 0 && t - v.t <= TTL && valid(v.p)) out = v.p;
    } catch (e) { out = ''; }
    return out;
  }

  function restore() {
    var loc = root.location, doc = root.document;
    if (!loc || !doc || !doc.body || doc.body.getAttribute('data-nc-auth') !== 'in') return false;
    var home = loc.pathname === '/' || /[?&]shop_sign_in=true(&|$)/.test(String(loc.search || ''));
    if (!home) return false;
    var to = take();
    if (!to || to === loc.pathname + (loc.search || '')) return false;
    loc.replace(to);
    return true;
  }

  var api = { valid: valid, save: save, take: take, restore: restore, KEY: KEY, TTL: TTL, PAGES: PAGES };
  root.NcReturnTo = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined' || root.__ncReturnToRan) return;
  root.__ncReturnToRan = true;
  restore();
})(typeof window !== 'undefined' ? window : globalThis);
